import { useContext, useState } from "react";
import { SearchContext } from "./context";
import { useScheduler } from "../scheduler";

export const useSearch = () => {
  const [touched, setTouched] = useState(false);
  const [query, setQuery] = useState("");

  const handleSetQuery = (q: string) => {
    setTouched(true);
    setQuery(q);
  };

  const clearQuery = () => setQuery("");
  return { query, touched, setQuery: handleSetQuery, clearQuery };
};

export const useScheduledSearch = <T>(callback?: (q: string) => Promise<T>) => {
  const [touched, setTouched] = useState(false);
  const [query, setQuery] = useState("");
  const [executedQuery, setExecutedQuery] = useState("");
  const { schedule, cancel } = useScheduler();

  const scheduleSearch = (q: string) =>
    schedule(() => {
      setExecutedQuery(q);
      callback?.(q);
    });

  const handleSetQuery = (q: string) => {
    setTouched(true);
    setQuery(q);
    scheduleSearch(q);
  };

  const reset = () => {
    cancel();
    setQuery("");
    setExecutedQuery("");
  };

  return { query, executedQuery, touched, setQuery: handleSetQuery, reset };
};

export const useSearchQueryProvider = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error("No SearchContext context was provided.");
  }
  return context;
};
